import { useNavigate } from '@exam-management/router';
import {
  Button,
  ErrorOutlineIcon,
  NoRowsOverlay,
  Flex,
  ArrowBackOutlinedIcon,
} from '@shared/components';

interface ResultNoRowOverlayProps {
  courseId: string;
}

export default function ResultNoRowsOverlay(props: Readonly<ResultNoRowOverlayProps>) {
  const { courseId } = props;
  const navigate = useNavigate();

  return (
    <Flex
      sx={{
        py: (theme) => theme.spacing(20),
      }}
    >
      <NoRowsOverlay
        icon={ErrorOutlineIcon}
        title='สร้าง QConfig ไม่สำเร็จ'
        description='ระบบไม่สามารถสร้าง QConfig ตามเงื่อนไขที่กำหนดได้ กรุณาตรวจสอบเงื่อนไขและลองใหม่อีกครั้ง'
        action={
          <Button
            variant='outlined'
            startIcon={<ArrowBackOutlinedIcon />}
            color='secondary'
            onClick={() => {
              navigate('/exam-courses/:courseId/qconfig-generators', {
                params: { courseId },
              });
            }}
          >
            Back
          </Button>
        }
        slotProps={{
          wrapper: {
            disablePadding: true,
          },
          icon: {
            fontSize: 100,
            color: 'error',
          },
        }}
      />
    </Flex>
  );
}
